<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t('packagesDashboard.orderDetails') }}</h6>
          <p class="font13 gray-col">
            {{ $t('packagesDashboard.orderDetailsDescription') }}
          </p>
        </div>
      </div>
      <div class="row" v-if="!packagesLoader">
        <div
          class="col-lg-6 col-12 mb-3"
          v-for="packagemain in packages"
          :key="packagemain.id"
        >
          <div class="package-box">
            <div class="for-style-only">
              <div class="flex-bet-main mb-2">
                <div class="flex-sm-gap">
                  <div class="star-box">
                    <i class="fa-solid fa-star"></i>
                  </div>
                  <div class="font-bold">{{ packagemain.name }}</div>
                </div>
                <div class="flex-sm-gap">
                  <div class="gray-col">
                    {{ $t('packagesDashboard.packageValue') }}:
                    <span class="color-main font-bold"
                      >{{ packagemain.price }} {{ $t('packagesDashboard.currency') }}</span
                    >
                  </div>
                </div>
              </div>
              <p class="gray-col font14">
                {{ packagemain.description }}
              </p>
            </div>
            <div class="for-style-only">
              <div class="flex-bet-main mb-2">
                <div class="flex-sm-gap">
                  <div class="gray-col">
                    {{ $t('packagesDashboard.packageDuration') }} :
                    <span class="color-main font-bold"
                      >{{ packagemain.duration }} {{ $t('packagesDashboard.dayUnit') }}</span
                    >
                  </div>
                </div>
                <div class="flex-sm-gap">
                  <div class="gray-col">
                    {{ $t('packagesDashboard.numberOfProperties') }} :
                    <span class="color-main font-bold"
                      >{{ packagemain.available_buildings }} {{ $t('packagesDashboard.buildingsUnit') }}</span
                    >
                  </div>
                </div>
              </div>
              <button
                class="main-btn mt-3 up full-wid"
                v-if="!packagemain.is_subscribe"
                @click="getWayId(packagemain.id, packagemain.price)"
              >
                {{ $t('packagesDashboard.subscribe') }}
              </button>
              <button
                v-if="packagemain.is_subscribe"
                class="main-btn mt-3 up full-wid bg-red"
                @click="unSubscribe(packagemain.id)"
              >
                {{ $t('packagesDashboard.unsubscribe') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Loader Section -->
      <div class="row" v-if="packagesLoader">
        <div class="col-12">
          <div class="text-center py-5">
            <div class="spinner-main mb-3"></div>
            <p class="gray-col">{{ $t('packagesDashboard.loadingPackages') }}</p>
          </div>
        </div>
      </div>
    </div>
  </main>
  <!-- packages modal  -->
  <Dialog v-model:visible="showPackages" modal :style="{ width: '600px' }">
    <div class="modal-body-main modal-sm-pad">
      <div class="top-modal">
        <div class="font18">{{ $t('packagesDashboard.paymentMethod') }}</div>
        <div class="font18 color-main">{{ packagePrice }} {{ $t('packagesDashboard.currency') }}</div>
      </div>
      <form action="" @submit.prevent="payNow" ref="form">
        <div class="all-ways">
          <div class="flex-sm-gap mb-3 mt-3" v-for="way in ways" :key="way.id">
            <input
              type="radio"
              :value="way.id"
              v-model="wayValue"
              class="mainRadio"
              :id="'way' + way.id"
              name="payment_type"
            />
            <label :for="'way' + way.id" class="pay-type-div">
              <img :src="payImg" class="payImgmain" alt="" />
              <div class="onlystyle">
                <div class="black mb-1">{{ way.name }}</div>
                <div class="gary-col font14">{{ $t('PackagesView.payWithMethod') }} {{ way.name }}</div>
              </div>
            </label>
          </div>
        </div>

        <div class="flex-group-me mb-3">
          <button
            type="submit"
            :disabled="disabled || !wayValue"
            class="main-btn w-modal up"
          >
            <div v-if="!disabled">{{ $t('packagesDashboard.pay') }}</div>
            <div class="loading" role="status" v-if="disabled">
              {{ $t('packagesDashboard.paying') }}
              <div class="spinner-small-white" v-if="disabled"></div>
            </div>
          </button>
        </div>
      </form>
    </div>
  </Dialog>

  <!-- success modal  -->
  <Dialog v-model:visible="showSuccess" modal :style="{ width: '600px' }">
    <div class="modal-body-main modal-pad">
      <div class="flex-group-me mb-3">
        <img :src="successImg" class="successImg" alt="" />
      </div>
      <h6 class="font-bold text-center black font19 mb-2">
        {{ $t('packagesDashboard.subscribedSuccess') }}
      </h6>
      <p class="main-p text-center">
        {{ $t('packagesDashboard.redirectingMessage') }}
      </p>
    </div>
  </Dialog>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";

import { ref, onMounted } from "vue";

import Dialog from "primevue/dialog";
import axios from "axios";
import { useToast } from "primevue/usetoast";

const toast = useToast();

// router
import { useRouter } from "vue-router";
const router = useRouter();

// reactive state
const statusApproved = ref("");
const form = ref(null);
const disabled = ref(false);
const packagesLoader = ref(false);
const packageId = ref(null);
const packagePrice = ref("");
const wayValue = ref(null);
const showPackages = ref(false);
const showSuccess = ref(false);
const payImg = ref(require("../assets/imgs/Path 22398.png"));
const successImg = ref(require("../assets/imgs/check.png"));
const packages = ref([]);
const ways = ref([]);
// functions
function payNow() {
  disabled.value = true;
  const fd = new FormData(form.value);
  fd.append("plan_id", packageId.value);

  axios
    .post("/manager/subscribe", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        showPackages.value = false;
        showSuccess.value = true;
        wayValue.value = null;
        getPackages();
        setTimeout(function () {
          showSuccess.value = false;
          router.push("/dashboardHome");
        }, 2000);
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
function unSubscribe(id) {
  console.log(id);
  disabled.value = true;
  const fd = new FormData();
  fd.append("plan_id", id);

  axios
    .post("/manager/unsubscribe", fd, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      if (response.data.key == "success") {
        toast.add({
          severity: "success",
          detail: `${response.data.msg}`,
          life: 3000,
        });
        getPackages();
      } else {
        toast.add({
          severity: "error",
          detail: `${response.data.msg}`,
          life: 3000,
        });
      }
      disabled.value = false;
    });
}
function getWayId(id, price) {
  packageId.value = id;
  packagePrice.value = price;
  showPackages.value = true;
}
function getPackages() {
  packagesLoader.value = true;
  axios
    .get("/manager/plans", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      console.log(response.data);
      packages.value = response.data.data?.plans;
      statusApproved.value = response.data.key;
    })
    .catch((error) => {
      console.error("Error fetching packages:", error);
      toast.add({
        severity: "error",
        detail: "Failed to load packages",
        life: 3000,
      });
    })
    .finally(() => {
      packagesLoader.value = false;
    });
}
function getWays() {
  axios
    .get("/manager/payment-types", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      ways.value = response.data.data;
    });
}

// lifecycle hooks
onMounted(() => {
  getPackages();
  getWays();
});
</script>
